import V from 'voUtils/V.js';
import DateEx from 'voUtils/DateEx.js';


import {
	doReq
}
from 'voUtils/RestEx.js';

import {
	findResultFields
}
from 'voUtils/BrowserEx.js';

export default {
	data: function () {
		return {
			units: [],
			imagesForModal: []
		};
	},
	beforeMount: function () {
		var results = this.$el.getElementsByClassName('unit-list-section');
		if (results.length) {
			this.resultFields = findResultFields(results[0].innerHTML, this.$el);
		}
		var facilityid;
		let el = document.querySelector("[data-facilityid]");
		if (el) {
			facilityid = parseInt(el.getAttribute('data-facilityid'), 10);
		}

		if (facilityid) {
			var groupid = this.getUnitGroupId(facilityid);
			var req = {
				fields: this.resultFields,
				filter: {
					unitgroupid: groupid
				},
				sorting: 'random',
				max: 6
			};

			doReq('searchUnits', req)
				.then((res) => {
					this.units = res.units;
				});
		}
	},

	mounted: function () {
		this.$nextTick(function () {
			window.addEventListener('resize', this.handleResize);
		});
	},

	updated: function () {

		$('[data-toggle="tooltip"]').tooltip();
		$('[data-toggle="popover"]').popover();


	},
	beforeDestroy: function () {
		window.removeEventListener('resize', this.handleResize);
	},
	methods: {

		getSearchUrl: function (facilityid) {
			return "s#?unitgroupid=" + this.getUnitGroupId(facilityid);
		},
		getUnitGroupId: function (facilityid) {
			var unitgroupid;
			if (facilityid == 228624) {
				unitgroupid = 70671;
			} else if (facilityid == 228625) {
				unitgroupid = 70673;
			} else if (facilityid == 227553) {
				unitgroupid = 70675;
			} else if (facilityid == 228626) {
				unitgroupid = 70676;
			} else if (facilityid == 228627) {
				unitgroupid = 70677;
			} else if (facilityid == 228628) {
				unitgroupid = 70678;
			} else if (facilityid == 228654) {
				unitgroupid = 70679;
			} else if (facilityid == 228629) {
				unitgroupid = 70680;
			} else if (facilityid == 228656) {
				unitgroupid = 70682;
			} else if (facilityid == 228630) {
				unitgroupid = 70681;
			} else if (facilityid == 228631) {
				unitgroupid = 70683;
			} else if (facilityid == 231694) {
				unitgroupid = 70684;
			}
			return unitgroupid;
		},


		handleEscKey: function (event) {
			if (event.key === 'Escape' || event.key === 'Esc') {
				const modals = document.querySelectorAll('.modal-custom');
				modals.forEach(modal => {
					if (modal.style.display === 'block') {
						modal.style.display = 'none';
						document.body.classList.remove('modal-open');
					}
				});

				window.removeEventListener('keydown', this.handleEscKey);

			}
		},
		showImagesModal: function (images, uniqueId = '') {
			if (images && images.length > 1) {
				this.imagesForModal = images;
				//$('#unitImages').modal('show');
				this.showCustomModal('unitImages' + uniqueId);

			} else {
				this.imagesForModal = [];
			}
		},
		showCustomModal: function (id) {

			let wh = window.innerHeight;

			// Get the modal
			const modal = document.getElementById(id);

			if (modal) {
				var dialog = modal.getElementsByClassName("modal-custom-dialog")[0];
				var content = modal.getElementsByClassName("modal-custom-content")[0];
				var body = document.body;

				if (dialog && content) {
					dialog.style.height = wh - 40 + "px";
					content.style.height = wh - 120 + "px";

					modal.style.display = "block";
					body.classList.add('modal-open');

					// ESC-Taste aktivieren
					window.addEventListener('keydown', this.handleEscKey);

					// When the user clicks anywhere outside of the modal, close it
					window.onclick = function (event) {
						if (event.target == modal) {
							modal.style.display = "none";
							body.classList.remove('modal-open');
						}
					};
				}
			}

		},

		closeCustomModal: function (id) {
			const modal = document.getElementById(id);
			var body = document.body;
			if (modal) {
				modal.style.display = "none";
				body.classList.remove('modal-open');
			}

		},
		getUnitSearchTarget: function (id) {
			return 'unit_' + id;
		},



	}
};